import { FC, memo, ReactNode } from 'react';

import { H3 } from '../../components/heading/Hx';

type ImpressumH3Props = {
  children?: ReactNode;
};

const ImpressumH3: FC<ImpressumH3Props> = ({ children }) => (
  <H3 center margin={{ top: '2.5rem' }}>
    {children}
  </H3>
);

export default memo(ImpressumH3);
